/**
 * Prototype UI — replace with Medplum hooks later.
 */

export type LedgerEntryType = 'charge' | 'payment' | 'adjustment' | 'write-off' | 'payer-payment';

export interface AccountLedgerEntry {
  date: string;
  type: LedgerEntryType;
  description: string;
  debit: number;
  credit: number;
  balance: number;
}

export interface AccountRow {
  id: string;
  clientName: string;
  guarantor: string;
  openBalance: number;
  lastPaymentAt: string;
  entries: AccountLedgerEntry[];
}

export const MOCK_ACCOUNTS: AccountRow[] = [];

export function findAccountById(id: string | undefined): AccountRow | undefined {
  if (!id) return undefined;
  return MOCK_ACCOUNTS.find((r) => r.id === id);
}
